<input type="text" autocomplete="disabled" [maxlength]="length" [(ngModel)]="strModel" numberForm [disabled]="setReadonly" ngDefaultControl
    (keyup)="onKeyTodo($event)" [ngClass]="{'error-border': isError && ulti.isNullOrEmpty(strModel)}"
    (focus)="focusIn($event.target.value)" (focusout)="focusOut($event.target.value)" class="form-control"
    [class]="ngClassName" [id]="strId">
<span *ngIf="isError && ulti.isNullOrEmpty(strModel)" class="text-error">
    {{ulti.stringFormat([trans.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED'),
    trans.instant('STR_PHONENUM')])}}
</span>